export default "__VITE_ASSET__CWynnMB2__"